export default __webpack_public_path__ + "static/media/misc-bathtubA-1440w.5ccd2b63.png";